import DOMPurify from "dompurify";
import styled from "styled-components";

const JobDescHtml = styled.div`
  color: ${({ theme }) => theme.ink}CC !important;
  font-size: 1rem !important;
  font-family: Inter, system-ui, "Segoe UI", sans-serif !important;
  margin-bottom: 0.5rem;
  flex: 1;
  line-height: 1.6;
  word-break: break-word;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  li,
  span,
  div {
    font-size: 1rem !important;
    font-family: inherit !important;
    color: ${({ theme }) => theme.ink}CC !important;
  }
  strong,
  b {
    font-weight: bold;
    font-family: inherit !important;
    font-size: 1rem !important;
  }
  em,
  i {
    font-style: italic;
    font-family: inherit !important;
    font-size: 1rem !important;
  }
  /* Scraped postings can carry fixed-width tables, images and preformatted
     blocks; on a phone those ran past the card instead of fitting it. */
  @media (max-width: 768px) {
    img {
      max-width: 100%;
      height: auto;
    }
    table {
      display: block;
      max-width: 100%;
      overflow-x: auto;
    }
    pre {
      white-space: pre-wrap;
    }
  }
`;
export default function JobDescriptionHtml({ html }) {
  if (!html) return null;

  // Remove all literal \n characters from the string
  const cleanedHtml = html.replace(/\\n/g, "");

  return (
    <JobDescHtml
      className="job-description-html"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cleanedHtml) }}
    />
  );
}
